import React, { useContext, useEffect, useState } from 'react'
import classes from '../pages/destinations/destinations.module.scss'
import { Accordion } from 'react-accessible-accordion'
import ApiContext from '../../utils/api-context'
import RetreatRoom from './retreat-room'

const RetreatRooms = ({
  rooms,
  fromPrice,
  updateCheapest,
  fromDate,
  selectedRoom,
  updateSelectedRoom,
}) => {
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  return (
    <>
      <Accordion className={classes.roomAccordion} preExpanded={['option1']}>
        {rooms.map((room, i) => {
          return (
            <React.Fragment key={i}>
              <RetreatRoom
                room={room}
                fromDate={fromDate}
                fromPrice={fromPrice}
                accordionIndex={i}
                selectedRoom={selectedRoom}
                updateSelectedRoom={updateSelectedRoom}
              />
            </React.Fragment>
          )
        })}
      </Accordion>
    </>
  )
}

export default RetreatRooms
